import { Card } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import { cn } from "@/lib/utils";
import { RecordPageShell } from "./record-page-shell";
import { RECORD_CARD_CLASS, RECORD_DENSITY } from "./record-table-body";

const SKELETON_ROW_COUNT = 8;

const SKELETON_COLUMN_WIDTHS = ["w-24", "w-28", "w-40", "w-20", "w-28", "w-32"];

interface RecordTableSkeletonProps {
  label: string;
  className?: string;
  pageFill?: boolean;
  showHeader?: boolean;
}

export function RecordTableSkeleton({
  label,
  className,
  pageFill = false,
  showHeader = true,
}: RecordTableSkeletonProps) {
  return (
    <RecordPageShell pageFill={pageFill} className={cn("gap-3", className)}>
      {showHeader ? <div aria-hidden="true" className="h-11 shrink-0" /> : null}
      <Card
        role="status"
        aria-label={`Loading ${label.toLowerCase()}`}
        style={RECORD_DENSITY}
        className={RECORD_CARD_CLASS}
      >
        <div className="flex h-[49px] shrink-0 items-center border-b border-border px-2.5">
          <Skeleton className="h-8 w-full max-w-80" />
        </div>
        <div className="h-[var(--table-header-height)] shrink-0 border-b border-border bg-surface-2" />
        <div className="min-h-0 flex-1 overflow-hidden">
          {Array.from({ length: SKELETON_ROW_COUNT }, (_, rowIndex) => (
            <div
              key={rowIndex}
              className="flex h-[calc(var(--table-row-height)+1px)] items-center gap-6 border-b border-border px-[var(--table-cell-px)]"
            >
              {SKELETON_COLUMN_WIDTHS.map((width, cellIndex) => (
                <Skeleton
                  key={cellIndex}
                  className={cn(
                    "h-3 shrink-0",
                    (rowIndex + cellIndex) % 2 ? "w-16" : width,
                  )}
                />
              ))}
            </div>
          ))}
        </div>
      </Card>
    </RecordPageShell>
  );
}
